@if (showExamples) {
  <div class="flex flex-wrap gap-2">
    @for (color of examples; track color) {
      <button
        type="button"
        class="w-10 h-10 rounded-full border-2 transition-all hover:scale-110 relative flex items-center justify-center"
        [style.background-color]="color"
        [class.ring-ruber]="colorControl.value === color && !isCustomMode()"
        [class.ring-1]="colorControl.value === color && !isCustomMode()"
        [attr.aria-label]="color"
        (click)="selectExample(color)">
        @if (colorControl.value === color && !isCustomMode()) {
          <mat-icon
            class="icon-sm"
            [style.color]="getContrastTextColor(color)"
            svgIcon="remix:System/check-line" />
        }
      </button>
    }
    <button
      type="button"
      class="w-10 h-10 rounded-full border-2 border-divider transition-all hover:scale-110 relative flex items-center justify-center"
      [style.background-color]="isCustomMode() ? safeColor : 'transparent'"
      [class.ring-ruber]="isCustomMode()"
      [class.ring-1]="isCustomMode()"
      [matTooltip]="'libs.color-picker.custom-tooltip' | translate"
      (click)="activateCustomMode()">
      @if (isCustomMode()) {
        <mat-icon
          class="icon-sm"
          [style.color]="getContrastTextColor(safeColor)"
          svgIcon="remix:System/check-line" />
      } @else {
        <mat-icon
          class="icon-sm text-secondary"
          svgIcon="remix:Design/sip-line" />
      }
    </button>
  </div>
}

@if (!showExamples || isCustomMode()) {
  <div class="flex flex-col">
    <div class="mt-3 flex items-center gap-2">
      <div class="relative w-10 h-10">
        <input
          type="color"
          class="absolute inset-0 w-10 h-10 rounded-full cursor-pointer opacity-0"
          [value]="colorControl.value"
          (input)="onNativeColorChange($event)"
          (change)="onNativeColorChange($event)" />
        <div
          class="absolute inset-0 w-10 h-10 rounded-full border-2 border-divider flex items-center justify-center pointer-events-none"
          [style.background-color]="safeColor">
          <mat-icon
            class="icon-sm"
            [style.color]="getContrastTextColor(safeColor)"
            svgIcon="remix:Design/sip-line" />
        </div>
      </div>
      <mat-form-field
        subscriptSizing="dynamic"
        class="flex-1">
        <input
          matInput
          type="text"
          [formControl]="colorControl"
          placeholder="#1335d8"
          maxlength="7" />
      </mat-form-field>
    </div>
    @if (colorControl.invalid && (colorControl.dirty || colorControl.touched)) {
      <mat-error class="ml-12">{{ "validation.invalid-hex-color" | translate }}</mat-error>
    }
  </div>
}
